import { apiClientV2 } from "../../apiClient";

const baseURL = process.env.VUE_APP_API_FLEET_PLANNING_URL;

export const get = async () => {
    const response = await apiClientV2({
        baseURL,
        method: 'GET',
        url: '/setting',
    });

    return response?.data;
};

export const update = async (data) => {
    const response = await apiClientV2({
        baseURL,
        method: 'PATCH',
        url: '/setting',
        data
    });

    return response?.data;
};

